/* eslint-disable no-console */
import {Flex, Select} from 'antd';
import React, {useEffect, useState} from 'react';

import {filterSelectOptions} from '../../../../components/Forms/Utils/commonFunctions';
import useJSONStore from '../../../../store/StaticJson/jsonStore';

const FacilityFilterGeneralized: React.FC<{
  setMainData: React.Dispatch<React.SetStateAction<any[]>>;
  subData: any[];
}> = ({setMainData, subData}) => {
  const [selCountry, setSelCountry] = useState<number | undefined>(undefined);
  const [selState, setSelState] = useState<number | undefined>(undefined);
  const {country, states} = useJSONStore.getState();

  useEffect(() => {
    let filterData = subData;

    if (selCountry) {
      filterData = filterData.filter((item) => {
        return item?.countryId === selCountry;
      });
    }

    if (selState) {
      filterData = filterData.filter((item) => {
        return item?.stateId === selState;
      });
    }

    setMainData(filterData);
  }, [selCountry, selState]);

  return (
    <Flex gap="0.5rem">
      <Select
        showSearch
        allowClear
        className="select"
        placeholder={'By Country'}
        filterOption={filterSelectOptions}
        options={country.filter((item) => {
          return subData?.some((subItem) => {
            return subItem.countryId === item.value;
          });
        })}
        onChange={(e) => {
          setSelCountry(e);
          setSelState(undefined);
        }}
        style={{width: '20%'}}
        dropdownStyle={{zIndex: 100}}
      />
      <Select
        showSearch
        allowClear
        className="select"
        placeholder={'By State'}
        value={selState}
        filterOption={filterSelectOptions}
        options={
          states.filter((item) => {
            return (
              item.country_id === selCountry &&
              subData?.some((subItem) => {
                return subItem.stateId === item.value;
              })
            );
          }) ?? []
        }
        onChange={(e) => {
          setSelState(e);
        }}
        style={{width: '20%'}}
        dropdownStyle={{zIndex: 100}}
      />
    </Flex>
  );
};

export default FacilityFilterGeneralized;
